import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-generate-device",
  templateUrl: "./admin-generate-device.component.html",
  styleUrls: ["./admin-generate-device.component.css"],
})
export class AdminGenerateDeviceComponent implements OnInit {
  deviceForm: FormGroup;
  GpsTypeData: any = [];
  dataSource = new MatTableDataSource<any[]>(this.GpsTypeData);
  token: any;
  loading: boolean = false;
  serverName: any = -1;
  perPage: any = 10;
  page: any = 1;

  constructor(
    private formBuilder: FormBuilder,
    private matdialogref: MatDialogRef<AdminGenerateDeviceComponent>,
    private service: AdminService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.deviceForm = this.formBuilder.group({
      _id: ["", Validators.compose([Validators.required])],
    });
    this.getGpsType();
  }

  public close() {
    this.matdialogref.close();
  }

  public submit() {
    if (this.deviceForm.valid) {
      this.loading = true;
      this.service
        .autoGenerate(this.token, this.deviceForm.value._id)
        .subscribe(
          (response: any) => {
            if (response.status == 200) {
              this.loading = false;
              this.snackBar.open(
                "New vehicles will be added background.",
                "Success",
                {
                  duration: 5000,
                }
              );
              this.matdialogref.close();
            }
          },
          (error) => {
            this.loading = false;
            if (error.error.message === "jwt malformed") {
              this.router.navigateByUrl("admin/login");
              window.localStorage.clear();
            }
            if (error.error.message === "jwt expired") {
              this.router.navigateByUrl("admin/login");
              window.localStorage.clear();
            }
            if (error.error.message === "invalid signature") {
              this.router.navigateByUrl("admin/login");
              window.localStorage.clear();
            }
            this.snackBar.open(error.error.message, "Fail", {
              duration: 5000,
            });
          }
        );
    }
  }

  public getGpsType() {
    this.service
      .GetGpsType(this.token, this.serverName, this.perPage, this.page)
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.GpsTypeData = response.body.data;
            this.dataSource.data = this.GpsTypeData;
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
}
